













import { Component, Vue, Prop } from 'vue-property-decorator';
import { ContentLoader } from '@tencent/wphk-components-content-loader';

/**
 * 骨架内容
 */
@Component({
  components: {
    ContentLoader,
  },
})
export default class WeCouponsContentLoader extends Vue {
  @Prop({ default: 460 }) height!: number;

  get viewBox() {
    return `0 0 343 ${this.height}`;
  }
}
